import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { G, Path, Rect, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import { getPaymentBadgeColors } from './paymentBadgeColors';

export interface PayInPersonBadgeIconProps extends SvgProps {
  width?: number;
  height?: number;
  selected?: boolean;
}

const PayInPersonBadgeIcon: React.FC<PayInPersonBadgeIconProps> = ({
  width = 38,
  height = 24,
  selected = false,
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  const { background, foreground } = getPaymentBadgeColors(selected);

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 38 24"
      fill="none"
      {...props}
    >
      <Rect height="24" rx="3" width="38" fill={colors[background]} />
      <G fill={colors[foreground]}>
        <Path d="M22.8 6H15.2L13 9V10.5C13 11.3284 13.6716 12 14.5 12C15.3284 12 16 11.3284 16 10.5C16 11.3284 16.6716 12 17.5 12C18.3284 12 19 11.3284 19 10.5C19 11.3284 19.6716 12 20.5 12C21.3284 12 22 11.3284 22 10.5C22 11.3284 22.6716 12 23.5 12C24.3284 12 25 11.3284 25 10.5V9L22.8 6Z" />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 13.9655V17.0009C14 17.5532 14.4477 18.0009 15 18.0009H23C23.5523 18.0009 24 17.5532 24 17.0009V13.9655C23.8367 13.9888 23.6698 14.0009 23.5 14.0009C22.9632 14.0009 22.4546 13.88 22 13.6641C21.5454 13.88 21.0368 14.0009 20.5 14.0009C19.9632 14.0009 19.4546 13.88 19 13.6641C18.5454 13.88 18.0368 14.0009 17.5 14.0009C16.9632 14.0009 16.4546 13.88 16 13.6641C15.5454 13.88 15.0368 14.0009 14.5 14.0009C14.3302 14.0009 14.1633 13.9888 14 13.9655ZM20.5 15V18H17.5V15H20.5Z"
        />
      </G>
    </Svg>
  );
};

PayInPersonBadgeIcon.displayName = 'PayInPersonBadgeIcon';
export { PayInPersonBadgeIcon };
